module.exports = __webpack_public_path__ + "static/media/reachcustomermainnew.3866f686.png";